import React, { useState } from 'react';

import { FlexColumn } from '@editor/components/utilities/layouts';
import { withEventScope } from '@repo/event-processor';
import { Button, secondaryTheme } from '@repo/ui/components/Buttons';
import StarIcon from '@repo/ui/components/Icon/StarIcon';
import { Spacer } from '@repo/ui/components/Spacer';
import { themeStyle } from '@repo/ui/theming';
import { buildWebsiteUrl } from '@repo/utils/url';

import Variation from '../../../Variation/Variation';
import { ResponsiveHeader, ResponsiveButtonsWrapper } from '../styles';

import { HighlightWrapper, Subtitle } from './styles';
import { DiscountOfferContentProps } from './types';

const DiscountOfferContent: React.FC<DiscountOfferContentProps> = ({
  icon: Icon,
  heading,
  discountOptionTitle,
  discountOptionSubtitle,
  onBackClick,
  onDiscountAccept,
  onSubscriptionCancel,
}) => {
  const [activeOptionIndex, setActiveOptionIndex] = useState(0);

  const options = [
    {
      title: discountOptionTitle,
      subtitle: discountOptionSubtitle,
      highlight: true,
      nextButton: {
        onClick: onDiscountAccept,
      },
    },
    {
      title: 'Cancel my subscription',
      subtitle:
        'Lose access to AI credits, premium content, commercial license and more.',
      nextButton: {
        onClick: onSubscriptionCancel,
      },
    },
    {
      title: 'Keep my subscription',
      subtitle: 'Keep using Kittl as before',
      nextButton: {
        onClick: (): void => {
          window.open(buildWebsiteUrl('/designs/all'));
        },
      },
    },
  ] as const;

  const { nextButton } = options[activeOptionIndex];

  return (
    <>
      <Icon />
      <Spacer height="16px" />
      <ResponsiveHeader style={{ textAlign: 'center' }}>
        {heading}
      </ResponsiveHeader>
      <Spacer height="80px" />
      <FlexColumn gap="16px">
        {options.map((option, index) => {
          const isActive = index === activeOptionIndex;

          return (
            <Variation
              key={option.title}
              isActive={isActive}
              label={option.title}
              onClick={(): void => setActiveOptionIndex(index)}
            >
              {'highlight' in option && option.highlight ? (
                <HighlightWrapper isActive={isActive}>
                  <StarIcon
                    height="14px"
                    theme={{ color: themeStyle.backgroundAlt }}
                  />
                  {option.subtitle}
                </HighlightWrapper>
              ) : (
                <Subtitle>{option.subtitle}</Subtitle>
              )}
            </Variation>
          );
        })}
      </FlexColumn>
      <Spacer height="80px" />
      <ResponsiveButtonsWrapper style={{ alignSelf: 'stretch' }}>
        <Button
          label="Back to billing"
          name="backToBillingButton"
          theme={secondaryTheme}
          width="100%"
          onClick={onBackClick}
        />
        <Button
          label="Next"
          name="nextDiscountOfferButton"
          width="100%"
          {...nextButton}
        />
      </ResponsiveButtonsWrapper>
    </>
  );
};

export default withEventScope(DiscountOfferContent, {
  module: 'discountOfferContent',
});
